import { createPivotTransformer } from './create-pivot-transformer';

/** Pivot = V. */
export const VOLTAGE_PIVOT: Record<string, number> = {
  v: 1,
  vac: 1,
  vdc: 1,
  mv: 0.001,
  uv: 1e-6,
  kv: 1000,
};

/** Pivot = A. */
export const CURRENT_PIVOT: Record<string, number> = {
  a: 1,
  ma: 0.001,
  ua: 1e-6,
  ka: 1000,
  fla: 1,
};

/** Pivot = Ω. */
export const RESISTANCE_PIVOT: Record<string, number> = {
  ohm: 1,
  kohm: 1000,
  mohm: 1e6,
};

export const transformVoltage = createPivotTransformer(VOLTAGE_PIVOT);
export const transformCurrent = createPivotTransformer(CURRENT_PIVOT);
export const transformResistance = createPivotTransformer(RESISTANCE_PIVOT);
